export default "__VITE_ASSET__953BxHEY__"